export default "__VITE_ASSET__XD61tLpS__"